var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckiconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.716 30 0 23.284 0 15C0 6.716 6.716 0 15 0C23.284 0 30 6.716 30 15C30 23.284 23.284 30 15 30ZM15 28C22.18 28 28 22.18 28 15C28 7.82 22.18 2 15 2C7.82 2 2 7.82 2 15C2 22.18 7.82 28 15 28ZM9.707 14.293L13 17.586L20.293 10.293C20.4816 10.1108 20.7342 10.01 20.9964 10.0123C21.2586 10.0146 21.5094 10.1198 21.6948 10.3052C21.8802 10.4906 21.9854 10.7414 21.9877 11.0036C21.99 11.2658 21.8892 11.5184 21.707 11.707L13.777 19.637C13.5707 19.8431 13.2911 19.9589 12.9995 19.9589C12.7079 19.9589 12.4283 19.8431 12.222 19.637L8.292 15.707C8.10449 15.5194 7.9992 15.2649 7.9993 14.9996C7.99939 14.7344 8.10486 14.48 8.2925 14.2925C8.48014 14.105 8.73458 13.9997 8.99985 13.9998C9.26512 13.9999 9.51949 14.1054 9.707 14.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckiconWhite);
export default __webpack_public_path__ + "static/media/checkicon_white.5171e35452b724e1aabc4b2ac1d857a3.svg";
export { ForwardRef as ReactComponent };